import React, { Component } from "react";
import gageBio from "../../../assets/images/gage-bio.jpg";
import derekBio from "../../../assets/images/derek-bio.jpg";
import "../../../styles/pages/about/AboutBios.css";

export default class AboutBios extends Component {
  render() {
    return (
      <div className="AboutBios">
        {/* The Title Text */}
        <div className="title-container on-scroll-anim">
          <div className="g-title">GET TO KNOW US:</div>
        </div>

        {/* The Bios */}
        <div className="bio">
          {/* The Image */}
          <img className="on-scroll-anim" src={gageBio} alt="Gage." />

          {/* The Info */}
          <div className="text-container">
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-title name info">GAGE HENDERSON</div>
            </div>
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-text info">
                <b>Position:</b> Designer / Programmer
              </div>
            </div>
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-text info">
                <b>Location:</b> Canby, Oregon
              </div>
            </div>
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-text info">
                <b>Favorite Movie:</b> Napoleon Dynamite
              </div>
            </div>
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-text info">
                <b>How do you like your coffee?:</b> Black
              </div>
            </div>
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-text info">
                <b>Bio:</b> I’m the introverted computer guy who made this
                website - I handle everything technical and have a passion for
                creating stuff.
              </div>
            </div>
          </div>
        </div>

        <div className="bio">
          {/* The Image */}
          <img className="on-scroll-anim" src={derekBio} alt="Derek." />
          {/* The Info */}
          <div className="text-container">
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-title name">DEREK RIGGS</div>
            </div>
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-text info">
                <b>Position:</b> Producer / Business Developer
              </div>
            </div>
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-text info">
                <b>Location:</b> Canby, Oregon
              </div>
            </div>
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-text info">
                <b>Favorite Movie:</b> Shawshank Redemption
              </div>
            </div>
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-text info">
                <b>How do you like your coffee?:</b> With french vanilla
                creamer.
              </div>
            </div>
            <div className="about-info-container on-scroll-anim">
              <div className="g-sub-text info">
                <b>Bio:</b> I’m the professional talker, and most likely your
                point of contact. My job is to keep everyone happy. I handle the
                boring work and let Gage have all the fun.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
